import React, { useEffect, useState } from 'react'
import { Avatar, Button, Card, Col, Icons, Row } from '@pankod/refine-antd'

import { useTranslate, useGetIdentity, useList, useTable } from '@pankod/refine-core'

import './style.less'

import { IPaper, IPaperRequest, IQuestion } from 'interfaces'
import dayjs, { Dayjs } from 'dayjs'
import { getWorkRequestCount, getQuestionCount, getAcceptedQuestionCountCreators, getAcceptedQuestionCountReviewers } from 'gql/query'
import { useUserContext } from 'context/user'
// import DashBoardChart from 'components/chart/Chart'
import metaData from 'metadata/questions'
const { QuestionOutlined, ExceptionOutlined, ProjectOutlined, LikeOutlined, UserOutlined, RightCircleOutlined } = Icons

const { Meta } = Card

export const QUsersDashboard: React.FC = () => {
  const { data: user } = useGetIdentity()
  const role = user?.defaultRole

  const t = useTranslate()
  let now = dayjs()

  const [wrTotal, setWrTotal] = useState<any>(0)
  const [reviewTotal, setReviewTotal] = useState<any>(0)
  const [approveTotal, setApproveTotal] = useState<any>(0)
  const [closeTotal, setCloseTotal] = useState<any>(0)
  const [approvedTotal, setApprovedTotal] = useState<any>(0)
  const { changeUser, userRole } = useUserContext()

  const [paperRequestCount, setPaperRequestCount] = useState<any>(0)
  const [paperPendingCount, setPaperPendingCount] = useState<any>(0)
 useEffect(()=>{
  if(userRole==='qcreator'){
    getAcceptedQuestionCountCreators(user?.id).then((resp:any)=>{
      setApprovedTotal(resp?.questions_aggregate?.aggregate?.count)
      // console.log({resp})
    })
  }
  if(userRole==='qreviewer'){
    setApproveTotal(0)
    getAcceptedQuestionCountReviewers(user?.id).then((resp:any)=>{
      setApprovedTotal(resp?.questions_aggregate?.aggregate?.count)
      // console.log({resp})
    })
  }

 },[userRole])

  // useEffect(() => {
  //   changeUser(user?.defaultRole)
  // }, [user])
  useEffect(() => {
    let arrFilter: object[] = []
    let reviewListFilter: object[] = []
    let approveListFilter: object[] = []
    let closeListFilter: object[] = []
    let approvedListFilter:object[]=[]
    reviewListFilter.push({
      field: 'status',
      operator: '_eq',
      value: 'For Review',
    })
    approveListFilter.push({
      field: 'status',
      operator: '_eq',
      value: 'For Approval',
    })
    closeListFilter.push({
      field: 'status',
      operator: '_eq',
      value: 'Closed',
    })

    if (userRole === 'qcreator' || userRole === 'qapprover' || userRole === 'qreviewer' || userRole === 'variantcreator') {
      arrFilter.push({
        field: 'status',
        operator: '_neq',
        value: 'Draft',
      })

      if (userRole === 'qcreator') {
        arrFilter.push({
          field: 'creator_id',
          operator: '_eq',
          value: user?.id,
        })
        arrFilter.push({
          field: 'request_type',
          operator: '_eq',
          value: 'Q',
        })
       
        closeListFilter.push({
          field: 'creator_id',
          operator: '_eq',
          value: user?.id,
        })
        reviewListFilter.push({
          field: 'creator_id',
          operator: '_eq',
          value: user?.id,
        })
        approveListFilter.push({
          field: 'creator_id',
          operator: '_eq',
          value: user?.id,
        })
      }
      if (userRole === 'variantcreator') {
        arrFilter.push({
          field: 'creator_id',
          operator: '_eq',
          value: user?.id,
        })
        arrFilter.push({
          field: 'request_type',
          operator: '_eq',
          value: 'V',
        })
        closeListFilter.push({
          field: 'creator_id',
          operator: '_eq',
          value: user?.id,
        })
        closeListFilter.push({
          field: 'request_type',
          operator: '_eq',
          value: 'V',
        })
        reviewListFilter.push({
          field: 'creator_id',
          operator: '_eq',
          value: user?.id,
        })
        reviewListFilter.push({
          field: 'request_type',
          operator: '_eq',
          value: 'V',
        })
        approveListFilter.push({
          field: 'creator_id',
          operator: '_eq',
          value: user?.id,
        })
        approveListFilter.push({
          field: 'request_type',
          operator: '_eq',
          value: 'V',
        })
      }
      if (userRole === 'qapprover') {
        arrFilter.push({
          field: 'all_approver_ids',
          operator: '_contains',
          value: user?.id,
        })
        closeListFilter.push({
          field: 'all_approver_ids',
          operator: '_contains',
          value: user?.id,
        })
        reviewListFilter.push({
          field: 'approver_id',
          operator: '_eq',
          value: user?.id,
        })
        approveListFilter.push({
          field: 'approver_id',
          operator: '_eq',
          value: user?.id,
        })
      }
      if (userRole === 'qreviewer') {
        arrFilter.push({
          field: 'reviewer_ids',
          operator: '_contains',
          value: user?.id,
        })
        closeListFilter.push({
          field: 'reviewer_ids',
          operator: '_contains',
          value: user?.id,
        })
        reviewListFilter.push({
          field: 'reviewer_id',
          operator: '_eq',
          value: user?.id,
        })
        approveListFilter.push({
          field: 'reviewer_id',
          operator: '_eq',
          value: user?.id,
        })
      }
    } else if (userRole === 'subjectincharge') {
      arrFilter.push({
        field: 'created_by',
        operator: '_eq',
        value: user?.id,
      })
      closeListFilter.push({
        field: 'created_by',
        operator: '_eq',
        value: user?.id,
      })
      reviewListFilter.push({
        field: 'created_by',
        operator: '_eq',
        value: user?.id,
      })
      approveListFilter.push({
        field: 'created_by',
        operator: '_eq',
        value: user?.id,
      })
    }
    let condition = ''
    arrFilter.length > 0 &&
      arrFilter.forEach((element: any) => {
        if (element.field !== undefined && element.field !== null && element.field !== '') {
          let text = `${element.field}:{${element.operator}:"${element.value}"},`
          condition = condition.concat(text)
        }
      })
    let review_condition = ''
    reviewListFilter.length > 0 &&
      reviewListFilter.forEach((element: any) => {
        if (element.field !== undefined && element.field !== null && element.field !== '') {
          let text = ''
          if (userRole === 'subjectincharge') {
            if (element.field === 'created_by') {
              text = `work_request:{ ${element.field}:{${element.operator}:"${element.value}"}},`
            } else {
              text = `${element.field}:{${element.operator}:"${element.value}"},`
            }
          } else if (userRole === 'variantcreator') {
            if (element.field === 'request_type') {
              text = `work_request:{ ${element.field}:{${element.operator}:"${element.value}"}},`
            } else {
              text = `${element.field}:{${element.operator}:"${element.value}"},`
            }
          } else {
            text = `${element.field}:{${element.operator}:"${element.value}"},`
          }
          review_condition = review_condition.concat(text)
        }
      })
    let approve_condition = ''
    approveListFilter.length > 0 &&
      approveListFilter.forEach((element: any) => {
        if (element.field !== undefined && element.field !== null && element.field !== '') {
          let text = ''
          if (userRole === 'subjectincharge') {
            if (element.field === 'created_by') {
              text = `work_request:{ ${element.field}:{${element.operator}:"${element.value}"}},`
            } else {
              text = `${element.field}:{${element.operator}:"${element.value}"},`
            }
          } else if (userRole === 'variantcreator') {
            if (element.field === 'request_type') {
              text = `work_request:{ ${element.field}:{${element.operator}:"${element.value}"}},`
            } else {
              text = `${element.field}:{${element.operator}:"${element.value}"},`
            }
          } else {
            text = `${element.field}:{${element.operator}:"${element.value}"},`
          }
          approve_condition = approve_condition.concat(text)
        }
      })
    let close_condition = ''
    closeListFilter.length > 0 &&
      closeListFilter.forEach((element: any) => {
        if (element.field !== undefined && element.field !== null && element.field !== '') {
          let text = `${element.field}:{${element.operator}:"${element.value}"},`
          close_condition = close_condition.concat(text)
        }
      })
    // setWRFilter(condition)
    // setReviweFilter(review_condition)
    if (
      userRole === 'qreviewer' ||
      userRole === 'qapprover' ||
      userRole === 'qcreator' ||
      userRole === 'subjectincharge' ||
      userRole === 'variantcreator' ||
      userRole === 'qbincharge'
    ) {
      getWorkRequestCount(condition).then((resp: any) => {
        setWrTotal(resp?.work_requests_aggregate?.aggregate?.count)
      })
      getWorkRequestCount(close_condition).then((resp: any) => {
        setCloseTotal(resp?.work_requests_aggregate?.aggregate?.count)
      })
      getQuestionCount(review_condition).then((resp: any) => {
        setReviewTotal(resp?.questions_aggregate?.aggregate?.count)
      })
      getQuestionCount(approve_condition).then((resp: any) => {
        setApproveTotal(resp?.questions_aggregate?.aggregate?.count)
      })
    }
  }, [userRole])

  return (
    <div className="">
      {/* Question Creation Insights */}

      <>
        <Row gutter={16} className="mt-3">
          <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
            <div className="dashboard-card1">
              <Row className="card-content">
                <Col md={18} className="text-container">
                  <h4> Work Requests </h4>
                  <h3 style={{ margin: '0' }}>{wrTotal}</h3>
                </Col>
                <Col md={6} className="icon-container">
                  <ProjectOutlined className="icon" />
                </Col>
              </Row>
            </div>
          </Col>

          <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
            <div className="dashboard-card1">
              <Row className="card-content">
                <Col md={18} className="text-container">
                  <h4> Pending Reviews </h4>
                  <h3 style={{ margin: '0' }}>{reviewTotal > 0 ? reviewTotal : 0}</h3>
                </Col>
                <Col md={6} className="icon-container">
                  <ExceptionOutlined className="icon" />
                </Col>
              </Row>
            </div>
          </Col>
          <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
            <div className="dashboard-card1">
              <Row className="card-content">
                <Col md={18} className="text-container">
                  <h4> Pending Approvals</h4>
                  <h3 style={{ margin: '0' }}>{approveTotal}</h3>
                </Col>
                <Col md={6} className="icon-container">
                  <LikeOutlined className="icon" />
                </Col>
              </Row>
            </div>
          </Col>
          <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
            <div className="dashboard-card1">
              <Row className="card-content">
                <Col md={18} className="text-container">
                  <h4>Closed Work Requests </h4>
                  <h3 style={{ margin: '0' }}>{closeTotal}</h3>
                </Col>
                <Col md={6} className="icon-container">
                  <ProjectOutlined className="icon" />
                </Col>
              </Row>
            </div>
          </Col>
          {userRole==='qcreator'?
         <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
         <div className="dashboard-card1">
           <Row className="card-content">
             <Col md={18} className="text-container">
               <h4>Accepted Questions </h4>
               <h3 style={{ margin: '0' }}>{approvedTotal}</h3>
             </Col>
             <Col md={6} className="icon-container">
               <ProjectOutlined className="icon" />
             </Col>
           </Row>
         </div>
       </Col>
       :null  
        }
         {userRole==='qreviewer'?
         <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
         <div className="dashboard-card1">
           <Row className="card-content">
             <Col md={18} className="text-container">
               <h4>Accepted Questions </h4>
               <h3 style={{ margin: '0' }}>{approvedTotal}</h3>
             </Col>
             <Col md={6} className="icon-container">
               <ProjectOutlined className="icon" />
             </Col>
           </Row>
         </div>
       </Col>
       :null  
        }
        </Row>
      </>
      {/* {breakpoint.md&&<div style={{ marginTop: userRole === 'qcreator' || userRole === 'qreviewer' ? 0 : '4rem' }}>
        <DashBoardChart details={details} label={label} />
      </div>} */}
    </div>
  )
}
